/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class VmAgentsQuerySplunkStatus extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("VmAgentsQuerySplunkStatus");
    }

    getFixupPrototypeFunction() { return VmAgentsQuerySplunkStatus.fixupPrototype; }

    static newInstance(model: Partial<VmAgentsQuerySplunkStatus>): VmAgentsQuerySplunkStatus {
        let obj = Object.assign(new VmAgentsQuerySplunkStatus(), model);
        VmAgentsQuerySplunkStatus.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<VmAgentsQuerySplunkStatus>): VmAgentsQuerySplunkStatus {
        if (!model) return null;
        return VmAgentsQuerySplunkStatus.newInstance(<VmAgentsQuerySplunkStatus> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: VmAgentsQuerySplunkStatus) {
        if (!obj) return;

        models.VmAgentsQuerySplunkStatus.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: VmAgentsQuerySplunkStatus): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, VmAgentsQuerySplunkStatus.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Splunk Installation Status
     */
    splunk_status: Array<models.InstallationStatus>;

}
